import { render, staticRenderFns } from "./AddLessonTypeDialog.vue?vue&type=template&id=60481ead&scoped=true&"
import script from "@/views/Rooms/AddLessonTypeDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Rooms/AddLessonTypeDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Rooms/add-lesson-type-dialog.scss?vue&type=style&index=0&id=60481ead&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60481ead",
  null
  
)

export default component.exports